import React from "react";

/**
 * Hall-call indicator stripes for one floor cell.
 *
 * The stripes are rendered in their own quarter of the cell (each one fills
 * a 25% band) so all four directions+sides can be lit at the same time.
 * Each line is a sibling div with a stable key — when an unrelated bit of
 * state changes upstream React's reconciler keeps the existing DOM node
 * intact, preventing visible "blink" on unrelated re-renders.
 *
 * Wrapped in React.memo so re-renders of the parent (e.g. position updates
 * from the WebSocket stream) don't reach down into the stripes when their
 * four booleans are unchanged.
 *
 * Lives in its own file so React Fast Refresh has a clean module boundary
 * and survives hot reloads without losing the binding.
 */
function HallCallLinesInner({
  hasUpFront,
  hasUpRear,
  hasDownFront,
  hasDownRear,
}: {
  hasUpFront: boolean;
  hasUpRear: boolean;
  hasDownFront: boolean;
  hasDownRear: boolean;
}) {
  return (
    <>
      {hasUpFront && (
        <div
          key="up-front"
          data-testid="hall-call-up-front"
          className="monitoring__elevatorFullView__dotsStyleContainer monitoring__card__hallCalls__upFront"
          style={{ top: "0%" }}
        />
      )}
      {hasUpRear && (
        <div
          key="up-rear"
          data-testid="hall-call-up-rear"
          className="monitoring__elevatorFullView__dotsStyleContainer monitoring__card__hallCalls__upRear"
          style={{ top: "25%" }}
        />
      )}
      {hasDownFront && (
        <div
          key="down-front"
          data-testid="hall-call-down-front"
          className="monitoring__elevatorFullView__dotsStyleContainer monitoring__card__hallCalls__downFront"
          style={{ top: "50%" }}
        />
      )}
      {hasDownRear && (
        <div
          key="down-rear"
          data-testid="hall-call-down-rear"
          className="monitoring__elevatorFullView__dotsStyleContainer monitoring__card__hallCalls__downRear"
          style={{ top: "75%" }}
        />
      )}
    </>
  );
}
HallCallLinesInner.displayName = "HallCallLines";

const HallCallLines = React.memo(HallCallLinesInner);

export default HallCallLines;
